import type ProjectDirectoryType from '@jira/spa-apps__directories-projects-v3/src/ProjectDirectoryType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectsDirectory: LazyComponent<
	({
		isAdminProjectDirectoryRoute,
	}: {
		isAdminProjectDirectoryRoute?: boolean;
	}) => React.JSX.Element
> = lazyForPaint<typeof ProjectDirectoryType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-projects-directory-v3", jiraSpaEntry: "async-projects-directory-v3" */ '@jira/spa-apps__directories-projects-v3/src/ProjectDirectoryType.tsx'
		),
	),
);
